module.exports = __webpack_public_path__ + "static/media/rooms-ch1.54e64e62.png";